<template>
  <form @submit.prevent>
    <!-- ===================== ข้อมูลผู้เรียน ===================== -->
    <div class="card border-0 no-shadow bg-light mb-3">
      <div class="card-header border-0 bg-transparent">
        <h5 class="card-title">ข้อมูลผู้เรียน</h5>
      </div>
      <div class="card-body pb-0">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>รหัสนักเรียน</label>
            <b-form-input
              :value="member.studentId"
              type="text"
              class="form-control-plaintext text-muted"
              plaintext
              readonly
            ></b-form-input>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label>ชื่อ (ภาษาไทย) <span class="text-danger">*</span></label>
            <FormInputText
              :name="'firstName'"
              :required="true"
              :type="`text`"
              :value="member.firstName"
              :placeholder="`ชื่อ (ภาษาไทย)`"
              :is-editable="true"
              :errorText="'กรุณากรอกชื่อ'"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-md-6">
            <label>นามสกุล (ภาษาไทย) <span class="text-danger">*</span></label>
            <FormInputText
              :name="'lastName'"
              :required="true"
              :type="`text`"
              :value="member.lastName"
              :placeholder="`นามสกุล (ภาษาไทย)`"
              :is-editable="true"
              :errorText="'กรุณากรอกนามสกุล'"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label>ชื่อ (ภาษาอังกฤษ) <span class="text-danger">*</span></label>
            <FormInputText
              :name="'firstNameEn'"
              :required="true"
              :type="`text`"
              :value="member.firstNameEn"
              :placeholder="`ชื่อ (ภาษาอังกฤษ)`"
              :is-editable="true"
              :errorText="'กรุณากรอกชื่อ (ภาษาอังกฤษ)'"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-md-6">
            <label>นามสกุล (ภาษาอังกฤษ) <span class="text-danger">*</span></label>
            <FormInputText
              :name="'lastNameEn'"
              :required="true"
              :type="`text`"
              :value="member.lastNameEn"
              :placeholder="`นามสกุล (ภาษาอังกฤษ)`"
              :is-editable="true"
              :errorText="'กรุณากรอกนามสกุล (ภาษาอังกฤษ)'"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label>ชื่อเล่น</label>
            <FormInputText
              :name="'nickName'"
              :type="`text`"
              :value="member.nickName"
              :placeholder="`ชื่อเล่น`"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-md-6">
            <label>วันเดือนปีเกิด (ค.ศ 4 หลัก)</label>
            <FormInputText
              :name="'dateOfBirth'"
              :type="`date`"
              :value="member.dateOfBirth"
              :placeholder="`dd/mm/yyyy`"
              :maxDate="today"
              :gregorian-year="true"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label>เลขประจำตัวประชาชน</label>
            <FormInputText
              :name="'idCard'"
              :type="`text`"
              :value="member.idCard"
              :placeholder="`เลข 13 หลัก`"
              :max="'13'"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label>เพศ</label>
            <div v-if="editingGender" class="input-group mb-3">
              <b-form-select
                :value="(member.gender || '').toLowerCase()"
                :options="genderOptions"
                @change="onGenderChange"
              >
                <template #first>
                  <b-form-select-option :value="''" disabled
                    >เลือกเพศ</b-form-select-option
                  >
                </template>
              </b-form-select>
            </div>
            <div v-else class="input-group mb-3 border-bottom">
              <input
                type="text"
                class="form-control-plaintext text-muted"
                :value="genderLabel"
                readonly
              />
              <div class="input-group-append">
                <button
                  class="btn btn-link text-csq"
                  type="button"
                  @click="editingGender = true"
                >
                  <b-icon-pencil variant="secondary" />
                </button>
              </div>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label>ระดับชั้น</label>
            <b-form-input
              :value="gradeLabel(member.gradeLevel)"
              type="text"
              class="form-control-plaintext text-muted"
              plaintext
              readonly
            ></b-form-input>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            <label>โรงเรียน</label>
            <div v-if="editingSchool" class="d-flex align-items-center mb-3">
              <SchoolSelect
                class="flex-grow-1"
                :value="member.education"
                @input="onSchoolChange"
              />
              <button
                class="btn btn-link text-csq"
                type="button"
                @click="editingSchool = false"
              >
                ยกเลิก
              </button>
            </div>
            <div v-else class="input-group mb-3 border-bottom">
              <input
                type="text"
                class="form-control-plaintext text-muted"
                :value="member.education || '-'"
                readonly
              />
              <div class="input-group-append">
                <button
                  class="btn btn-link text-csq"
                  type="button"
                  @click="editingSchool = true"
                >
                  <b-icon-pencil variant="secondary" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label>เบอร์โทรศัพท์ <span class="text-danger">*</span></label>
            <FormInputText
              :name="'phoneNumber'"
              :required="true"
              :type="`text`"
              :value="member.phoneNumber"
              :placeholder="`0999999999`"
              :is-editable="true"
              :max="'15'"
              :errorText="'กรุณากรอกเบอร์โทรศัพท์'"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-md-6">
            <label>เบอร์โทรผู้ปกครอง (ไม่บังคับ)</label>
            <FormInputText
              :name="'parentPhone'"
              :type="`text`"
              :value="member.parentPhone"
              :placeholder="`0999999999`"
              :max="'15'"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>

        <b-row>
          <b-col>
            <TextareaForm
              name="about"
              :value="member.about"
              :is-editable="true"
              label="เกี่ยวกับผู้เรียน"
              class="mb-3"
              placeholder="เกี่ยวกับผู้เรียน"
              @edited="edit"
            />
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- ===================== ข้อมูลที่อยู่ ===================== -->
    <div class="card border-0 bg-light mb-3 no-shadow">
      <div class="card-header border-0 bg-transparent">
        <h5 class="card-title">ข้อมูลที่อยู่</h5>
      </div>
      <div class="card-body pb-0">
        <div class="form-row">
          <div class="form-group col-md-12">
            <TextareaForm
              name="address"
              :value="member.address"
              :is-editable="true"
              class="mb-3"
              label="ที่อยู่ (บ้านเลขที่ หมู่บ้าน ซอย ถนน)"
              placeholder="ที่อยู่"
              @edited="edit"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>แขวง/ตำบล</label>
            <FormInputText
              :name="'subDistrict'"
              :type="`text`"
              :value="member.subDistrict"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-md-6">
            <label>เขต/อำเภอ</label>
            <FormInputText
              :name="'district'"
              :type="`text`"
              :value="member.district"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>จังหวัด</label>
            <FormInputText
              :name="'province'"
              :type="`text`"
              :value="member.province"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-md-6">
            <label>รหัสไปรษณีย์</label>
            <FormInputText
              :name="'postcode'"
              :type="`text`"
              :value="member.postcode"
              :max="'5'"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================== ข้อมูลผู้ใช้งาน ===================== -->
    <div class="card border-0 bg-light mb-3 no-shadow">
      <div class="card-header border-0 bg-transparent">
        <h5 class="card-title">ข้อมูลผู้ใช้งาน</h5>
      </div>
      <div class="card-body pb-0">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>อีเมล <span class="text-danger">*</span></label>
            <b-form-input
              :value="member.email"
              type="text"
              class="form-control-plaintext text-muted"
              plaintext
              readonly
            ></b-form-input>
          </div>
          <div class="form-group col-md-6">
            <label>ชื่อผู้ใช้งาน</label>
            <FormInputText
              :name="'username'"
              :type="`text`"
              :value="member.username"
              :placeholder="`username`"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>สถานะ</label>
            <div v-if="editingStatus" class="input-group mb-3">
              <b-form-select
                :value="statusValue"
                :options="statusOptions"
                @change="onStatusChange"
              ></b-form-select>
            </div>
            <div v-else class="input-group mb-3 border-bottom">
              <input
                type="text"
                class="form-control-plaintext text-muted"
                :value="statusLabel"
                readonly
              />
              <div class="input-group-append">
                <button
                  class="btn btn-link text-csq"
                  type="button"
                  @click="editingStatus = true"
                >
                  <b-icon-pencil variant="secondary" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <b-row>
          <b-col>
            <TextareaForm
              name="lockReason"
              :value="member.lockReason"
              :is-editable="statusValue === 0"
              class="mb-3"
              label="เหตุผลการล็อค"
              placeholder="เหตุผลการล็อค"
              @edited="edit"
            />
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- ===================== เปลี่ยนรหัสผ่าน ===================== -->
    <div class="card border-0 bg-light mb-3 no-shadow">
      <div class="card-header border-0 bg-transparent">
        <h5 v-b-toggle.collapse-wns-password class="card-title">
          เปลี่ยนรหัสผ่าน
          <b-icon-chevron-compact-down class="float-right" />
        </h5>
      </div>
      <b-collapse id="collapse-wns-password">
        <div class="card-body pb-0">
          <change-password-form
            :companyId="comId"
            :errors="errors"
            :isSetPassword="null"
            :isSetConfirmPassword="null"
            @passwordConfirmed="changePassword"
          ></change-password-form>
        </div>
      </b-collapse>
    </div>
  </form>
</template>

<script>
import FormInputText from "./FormInputText";
import TextareaForm from "./TextareaForm";
import ChangePasswordForm from "./ChangePasswordForm.vue";
import SchoolSelect from "./SchoolSelect.vue";
import { gradeLevelText } from "@/helpers/grade-level";
import { genderList } from "@/helpers/gender";

export default {
  components: { FormInputText, TextareaForm, ChangePasswordForm, SchoolSelect },
  props: {
    member: { type: Object, default: null },
    errors: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      comId: this.$store.state.Company.companyInfo.id,
      editingGender: false,
      editingStatus: false,
      editingSchool: false,
      genderOptions: genderList(),
      statusOptions: [
        { text: "เปิดใช้งาน", value: 1 },
        { text: "ระงับการใช้งาน", value: 0 },
      ],
    };
  },
  computed: {
    today() {
      return new Date().toISOString().split("T")[0];
    },
    // mp_active: 1 = เปิดใช้งาน, 0 = ระงับการใช้งาน (default to active when unset)
    statusValue() {
      return this.member.disabled === 0 || this.member.disabled === "0" ? 0 : 1;
    },
    statusLabel() {
      const found = this.statusOptions.find(
        (option) => option.value === this.statusValue
      );
      return found ? found.text : "-";
    },
    genderLabel() {
      const g = (this.member.gender || "").toLowerCase();
      const found = this.genderOptions.find((option) => option.value === g);
      return found ? found.text : "-";
    },
  },
  methods: {
    gradeLabel(value) {
      return gradeLevelText(value);
    },
    onGenderChange(value) {
      this.edit({ name: "gender", value });
      this.editingGender = false;
    },
    onSchoolChange(value) {
      this.edit({ name: "education", value });
      this.editingSchool = false;
    },
    onStatusChange(value) {
      this.edit({ name: "disabled", value });
      if (value === 1) {
        this.member.lockReason = "";
        this.$emit("patched", { name: "lockReason", value: "" });
      }
      this.editingStatus = false;
    },
    edit(input) {
      // previousValue lets the parent roll the field back if the PATCH is rejected.
      const previousValue = this.member[input.name];
      this.member[input.name] = input.value;
      if (this.errors) this.errors[input.name] = null;
      this.$emit("patched", { ...input, previousValue });
      // Keep the Thai-specific name columns in sync with the primary name.
      if (input.name === "firstName") {
        this.$emit("patched", { name: "firstNameTh", value: input.value });
      }
      if (input.name === "lastName") {
        this.$emit("patched", { name: "lastNameTh", value: input.value });
      }
    },
    changePassword(data) {
      this.$emit("passwordChanged", data);
    },
  },
};
</script>
